import {gaScopes} from '../../util/uiconstants';

const mapping = (data) =>
	data.map(({gaScopeID: id, gaScopeName: label, isSubScope, gaScopeTypeID: typeId}) => ({
		id,
		label,
		isSubScope,
		typeId
	}));

export default (data) => {
	let newData = [];

	Object.keys(gaScopes).forEach((key) => {
		const typeId = gaScopes[key];

		const knowledge = data.find(({isSubScope, gaScopeTypeID}) => !isSubScope && gaScopeTypeID === typeId);
		if (knowledge) newData.push(knowledge);
		const custom = data
			.filter(({isSubScope, gaScopeTypeID}) => isSubScope && gaScopeTypeID === typeId)
			.sort((a, b) => a.gaScopeName.toLowerCase().localeCompare(b.gaScopeName.toLowerCase()));
		if (custom && custom.length !== 0) newData = [...newData, ...custom];
	});

	return mapping(newData);
};
